module.exports = __webpack_public_path__ + "static/images/my-backpack.34a31f4.png";